import { fetcher } from "helpers/fetcher";

import {
  TGetInactiveVacancyFitlerDataReq,
  TGetInactiveVacancyFitlerDataRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getInactiveVacanciesFilterData = async (
  payload?: TGetInactiveVacancyFitlerDataReq
) => {
  return await fetcher<
    TGetInactiveVacancyFitlerDataRes,
    TGetInactiveVacancyFitlerDataReq["data"]
  >(ENDPOINT.BU.GET_INACTIVE_VACANCIES_FILTER_DATA, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.BU.GET_INACTIVE_VACANCIES_FILTER_DATA.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
  });
};

export const queryGetInactiveVacanciesFilterData = async (
  params?: TGetInactiveVacancyFitlerDataReq
) => {
  return (await getInactiveVacanciesFilterData(params)).data;
};

queryGetInactiveVacanciesFilterData._key = (
  params?: TGetInactiveVacancyFitlerDataReq,
  key?: string
) => [ENDPOINT.BU.GET_INACTIVE_VACANCIES_FILTER_DATA.url, params, key];
